<template>
  <v-card-actions>
    <v-spacer></v-spacer>
    <v-tooltip bottom>
  <v-btn slot="activator" icon flat small @click="goRoute" :disabled="disableGoToPresentation">
      <v-icon color="primary">keyboard_arrow_right</v-icon>
      </v-btn>
      <span v-if="disableGoToPresentation">El informe está siendo corregido por LPF</span>
      <span v-if="!disableGoToPresentation">Ver Informe</span>
    </v-tooltip>
  </v-card-actions>
</template>

<script>
import constants from '../../../common/constants'

export default {
  props: {
    item: Object
  },

  computed: {
    disableGoToPresentation () {
      if (this.$store.getters.isSafRole) {
        return false
      } else {
        return this.clubCanEdit()
      }
    }
  },
  methods: {
    clubCanEdit () {
      if (this.item !== {}) {
        if (this.item.status === constants.INFORME_STATUS_PRESENTADO) {
          return true
        } else {
          return false
        }
      }
    },
    goRoute () {
      this.$router.push({ name: 'informe-auditoria', params: { id: this.item.pk } })
    }
  }
}
</script>
